import { Button, Container, Flex, Heading, Link, ScrollArea } from "@radix-ui/themes";
import BillService from "../../core/services/BillService";
import { useEffect, useState } from "react";
import { IBill } from "../../core/types/services-types/bill-types";
import useFetch from "../../core/hooks/useFetch";
import { toast, ToastContainer } from "react-toastify";
import Pagination from "../../components/common/renders/pagination-render";

export default function AdminAllBills() {
       const [totalBills, setTotalBills] = useState<number>(0)
        const [bills, setBills] = useState<IBill[]>([])
        const [pageBills, setPageBills] = useState<number>(0)
        const [limitBills, setLimitBills] = useState<number>(100)
     const [fetchBillForUser, isLoadingBillForUser, errorBillForUser, errorsBillForUser] = useFetch(async () => {
            const data = await BillService.GetBills(limitBills, pageBills)
            setTotalBills(data.count)
            setBills(prev => data.data)
    })
     const [fetchRemoveBill, isLoadingFetchRemoveBill, errorFetchRemoveBill, errorsFetchRemoveBill] = useFetch(async (id: number | string) => {
            await BillService.Remove(id)
            setBills(prev => prev.filter(item => item.id !== id))
            toast.success("Счет успешно удален!")
    })
    useEffect(() => {
        fetchBillForUser()
    }, [pageBills])
    useEffect(() => {
        if(errorFetchRemoveBill) toast.error(errorFetchRemoveBill)
    }, [errorFetchRemoveBill])
    useEffect(() => {
        if(errorBillForUser) toast.error(errorBillForUser)
    }, [errorBillForUser])
    return (
        <Container className="mt-20">
            <ToastContainer />
            <Flex className="bills bg-zinc-50 shadow-lg p-10 w-[100%] md:!width-auto" direction={'column'} wrap={'wrap'}>
                <Heading>ЗАЯВЛЕНИЯ-ТРЕБОВАНИЯ пользователей</Heading>
            </Flex>
             <Flex className="bills bg-zinc-50 shadow-lg p-10 w-[100%] md:!width-auto mt-20" direction={'column'} wrap={'wrap'}>
                <ScrollArea type="scroll" scrollbars="vertical" className="mt-5 max-h-[630px]">
                    {isLoadingBillForUser}
                    {
                        bills.map(item => {
                            return (
                                <Container className="mb-4">
                                    Номер: {item.id}. <Link download href={item.document}>Скачать docx</Link> <Link download href={item.document_pdf}>Скачать pdf</Link> <Button variant="solid" color="red" onClick={async () => await fetchRemoveBill(item.id)} loading={isLoadingFetchRemoveBill}>Удалить</Button>
                                </Container>
                            )
                        })
                    }
                </ScrollArea>
                <Pagination total={totalBills} count={limitBills} activeIndex={pageBills} onChangeIndex={setPageBills} />
            </Flex>
        </Container>
    )
}